var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"modal",class:_vm.classes,attrs:{"role":"dialog","aria-modal":"true","aria-labelledby":_vm.titleId},on:{"mousedown":_vm.handleBackdropClick,"keydown":_vm.handleKeydown}},[_c('div',{ref:"modalContent",staticClass:"box",style:(_vm.style),on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }